<div class="hours-page">
  <div class="container hours-shell">
    <section class="hours-hero">
      <div class="hours-identity">
        <div class="hours-badges">
          <span class="hours-chip">Mon planning</span>
        </div>
        <h1>Mes heures de conduite</h1>
      </div>

      <div class="hours-side">
        <div class="hours-summary">
          <div class="hours-stat">
            <span class="hours-stat-label">Heures consommées</span>
            <strong>{{ hoursConsumedTotal }}</strong>
          </div>
          <div class="hours-stat">
            <span class="hours-stat-label">Heures réservées</span>
            <strong>{{ pageDrivingEvent?.totalElements ?? drivingEvents.length }}</strong>
          </div>
        </div>
      </div>
    </section>

    <section class="hours-panel">
      <div class="hours-panel-head">
        <div>
          <span class="hours-panel-label">Vue active</span>
          <h2>Mes créneaux</h2>
        </div>
      </div>

      <app-driving-event-list [iShowDrivingEvents]="true" [iDrivingEvents]="drivingEvents" [iNavMobile]="false"
                              [iPageDrivingEvent]="pageDrivingEvent" (iPageNumber)="onChangeDrivingEventPage($event)">
      </app-driving-event-list>
    </section>
  </div>
</div>
